import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import icons from 'assets/icons'
import Spinner from 'components/loader/Spinner'
import React, { useState, useEffect } from 'react'
import Button from 'components/formElements/Button'
import PropTypes from 'prop-types'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { Calendar } from 'primereact/calendar'
import moment from 'moment'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { useDispatch, useSelector } from 'react-redux'
import { closeApprovalModal, openApprovalModal } from 'redux/features/general/generalSlice'
import ApprovalContent from 'components/modalContent/ApprovalContent'
import { getPermission } from 'utils/Auth'
import useWindowSize from 'hooks/useWindowSize'
import { calculateIzinGun, leaveDayPeriod } from 'utils/Constants'
import DefaultSelect from 'components/formElements/DefaultSelect'
import {Checkbox} from 'primereact/checkbox'
import { PickList } from 'primereact/picklist'

const Leave = () => {
    const initialDeveloperState = { open: false, developer: {}, isEdit: false }
    const [filterOptions, setFilterOptions] = useState({ searchString: '', startDate: null, endDate: null })
    const [request] = useRequest()
    const { showToast } = useToast()
    const { width } = useWindowSize()
    const [getDevelopersLoading] = useRequest()
    const dispatch = useDispatch()
    const { general } = useSelector((state) => state)
    const { approvalModal } = general
    const [developerLeave, setDeveloperLeave] = useState([])
	const [leaveTypes, setLeaveTypes] = useState([])
    const [filteredDeveloperLeaves, setFilteredDeveloperLeaves] = useState([])
    const [createDev, setCreateDev] = useState()
    const [editDeveloper, setEditDeveloper] = useState(initialDeveloperState)
    const [developerInfo, setDeveloperInfo] = useState({
        fullName: '',
		startDate: null,
		endDate: null,
		developerSkills: [],
		jiraUserId: '',
		email: '',
		departmentId: [],
		inOutSource:null
    })

    const [allUser, setAllUser] = useState([]);
    const [leaveDayPeriodList, setLeaveDayPeriodList] = useState([])
    const [time, setTime] = useState()
    const [time2, setTime2] = useState('')
    const [addDevForm, setAddDevForm] = useState({
        id: "",
        forWhomUserId: null,
        startDate: null,
        endDate: null,
        startDayPeriod: leaveDayPeriod[0].value,
        endDayPeriod: leaveDayPeriod[0].value,
        leaveTypeId: null,
        description: '',
        leaveText: null,
        isReduceLeave: 0,
				forWhomUserIds: [],
    })

    const handleCloseModal = () => {
        setEditDeveloper(initialDeveloperState)
        setCreateDev()
        setFilterOptions({ searchString: '', startDate: null, endDate: null })
    }

    useEffect(() => {

        setLeaveDayPeriodList(leaveDayPeriod.map((pt) => ({ label: pt?.type, value: pt.value })))
        if (createDev) {
            request('/Developer/GetAllDevelopers', {
                method: 'GET'
            }).then((res) => {
                if (res?.data?.result) {
                    let sortArr = res.data.result.sort((a, b) => a.fullName.localeCompare(b.fullName))
                    setAllUser(sortArr)
                    setAddDevForm({
                        forWhomUserId: null,
                        startDate: null,
                        endDate: null,
                        startDayPeriod: leaveDayPeriod[0].value,
                        endDayPeriod: leaveDayPeriod[0].value,
                        leaveTypeId: null,
                        description: '',
                        leaveText: null,
                        isReduceLeave: 0,
												forWhomUserIds: [],
										})
                }
            })
        } else if (!createDev) {
            request('/DeveloperLeave/GetAllLeaves', {
                method: 'GET',
            }).then((res) => {
                setDeveloperLeave(res.data.result)
            })
            request('/LeaveType/GetAllLeaveTypes', {
                method:'GET'
            }).then(res => {
                if (res?.data?.result?.length > 9) {
                    setLeaveTypes(res?.data?.result?.reverse()?.map(t => ({
                        label:t.name,
                        value:t.id
                    })))
                }
            })
        }

    }, [createDev])

    useEffect(() => {
        if (addDevForm.forWhomUserId) {
            request('/Developer/GetDeveloperById', {
                method: 'GET',
                params: {
                    id: addDevForm.forWhomUserId,
                },
            }).then((res) => {
                setDeveloperInfo(res.data.result)
            })
        }
    },[addDevForm])
    const handleDeleteRow = (deleteData, deleteEndpoint, datatable) => {
        dispatch(openApprovalModal({ open: true, content: 'İzini silmek istediğinize emin misiniz?', deleteData, deleteEndpoint, datatable }))
    }

    const handleSubmitApproval = () => {
        request(approvalModal.deleteEndpoint, {
            method: 'DELETE',
            data: { id: approvalModal.deleteData.id },
        }).then(async (res) => {
            if (!res.data.metadata) {
                handleCloseApprovalModal()
                request('/DeveloperLeave/GetAllLeaves', {
                    method: 'GET',
                }).then((res) => {
                    setDeveloperLeave(res.data.result)
                })

            } else if (res?.data?.metadata?.message) {
                showToast('Kayıt Silinemedi Kullanıcıya Ait Not Bilgisi Olmadığından Emin Olun.', 'error')
            }
        })
    }
    const handleCloseApprovalModal = async () => {
        dispatch(closeApprovalModal())
    }
    const handleChange = (e, name) => {
        if (name) {
            setAddDevForm((prev) => ({ ...prev, [name]: e }))
        } else {
            setAddDevForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
    }

    const handleSubmit = async () => {
        var times = time && moment(time).format("HH:mm");
        var times2 = time2 && moment(time2).format("HH:mm");

        var dates = moment(addDevForm.startDate).format("DD-MM-YYYY");
        var dates2 = moment(addDevForm.endDate).format("DD-MM-YYYY");

        var dateTime = moment(dates + times, 'DD-MM-YYYY HH:mm').add(3, 'hours').toISOString();
        var dateTime2 = moment(dates2 + times2, 'DD-MM-YYYY HH:mm').add(3, 'hours').toISOString();


        addDevForm.startDate = dateTime;
        addDevForm.endDate = dateTime2;

        if (!addDevForm.startDate) {
            showToast('İzin Başlangıç Tarihi Giriniz', 'error')
        } else if (!addDevForm.endDate) {
            showToast('İzin Bitiş Tarihi Giriniz', 'error')
        } else if (!addDevForm.leaveTypeId) {
            showToast('İzin Tipini Giriniz', 'error')
        }
        else {
            if (!addDevForm.id) {
								if (!(addDevForm.forWhomUserIds?.length > 0)) {
										showToast('En az bir kişi seçmelisiniz', 'error')
										return
								}

                const formDatas = new FormData()
                formDatas.append('StartDate', addDevForm.startDate)
                formDatas.append('EndDate', addDevForm.endDate)
                formDatas.append('StartDayPeriod', addDevForm.startDayPeriod)
                formDatas.append('EndDayPeriod', addDevForm.endDayPeriod)
                formDatas.append('LeaveTypeId', addDevForm.leaveTypeId)
                if (addDevForm.leaveText) {
                    formDatas.append('LeaveText', addDevForm.leaveText)
                }
                formDatas.append('IsReduceLeave', addDevForm.isReduceLeave)
                addDevForm.forWhomUserIds.forEach((id) => {
                    formDatas.append('ForWhomUserIds', id)
                })

                request('/DeveloperLeave/AddLeave', {
                    method:'POST',
                    data:formDatas
                }).then(res => {
                    if (res.data?.ok) {
                        showToast('Toplu İzin Bilgisi Eklendi', 'success')
                        setEditDeveloper(initialDeveloperState)
                        setDeveloperInfo({
                            fullName: '',
                            startDate: null,
                            endDate: null,
                            developerSkills: [],
                            jiraUserId: '',
                            email: '',
                            departmentId: [],
                            inOutSource: null,
                        })
                        setCreateDev()
                        request('/DeveloperLeave/GetAllLeaves', {
                            method: 'GET',
                        }).then((res) => {
                            setDeveloperLeave(res.data.result)
                        })
                    } else if (res.data?.metadata?.message) {
                        showToast(res.data.metadata.message, 'error')
                    }
								})
            } else {
                request('/DeveloperLeave/UpsertLeave', {
                    method: 'POST',
                    data: {
                        ...addDevForm,
                    },
                }).then((res) => {
									if (res.data?.ok) {
										showToast('İzin Bilgisi Düzenlendi', 'success')
										setEditDeveloper(initialDeveloperState)
										request('/DeveloperLeave/GetAllLeaves', {
											method: 'GET',
										}).then((res) => {
											setDeveloperLeave(res.data.result)
										})
									}
								})
            }
        }
    }

    const createDevFunc = () => {
        setCreateDev(true)
    }

    const handleFilterChange = (e, name, array) => {
        name = name || e.name;
        let value = array ? e : e.value;

        if (e.length == 0 || e.value == '') {
            value = null
        }

        setFilterOptions((prev) => ({...prev, [name]: value}))
    }

    useEffect(() => {
        setFilteredDeveloperLeaves(developerLeave.filter((l) => {
            let result = true

            if (filterOptions.searchString) {
                result &&= (l.forWhomUser?.fullName || l.leaveText || 'Genel İzin').toLowerCase().match(filterOptions.searchString.toLowerCase())
            }

            if (filterOptions.startDate) {
                result &&= moment(l.startDate).isSameOrBefore(filterOptions.startDate) && moment(l.endDate).isSameOrAfter(filterOptions.startDate)
            }

            if (filterOptions.endDate) {
                result &&= moment(l.endDate).isSameOrAfter(filterOptions.endDate) && moment(l.startDate).isSameOrBefore(filterOptions.endDate)
            }

            return result
        }))
    }, [filterOptions, developerLeave])

    return (
        <AnimatedSpan className='page-container d-flex flex-column'>
            {!getDevelopersLoading ? (
                <div className='d-flex w-100 justify-content-center'>
                    <Spinner size={3} />
                </div>
            ) : (
                <DataTable
                    stripedRows
                    paginator
                    responsiveLayout="scroll"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                    paginatorLeft={<Button type="button" className="p-button-text" />}
                    paginatorRight={<Button type="button" className="p-button-text" />}
                    emptyMessage="Hiç Kayıt Bulunamadı"
                    rows={25}
                    className='col-md-12 p-1'
                    size='small'
                    dataKey='id'
                    header={() => (
                        <div className='d-flex justify-content-between gap-3'>
                            <div className='row flex-1'>
                                <div className='col-md-3 pl-0'>
									<span className='p-input-icon-left w-100'>
										<i className='pi pi-search' />
                                        {filterOptions.searchString && <i className="pi pi-times" style={{cursor: 'pointer', right: '10px'}} onClick={() => setFilterOptions({ ...filterOptions, searchString: '' })} />}
                                        <input
                                            className='default-input pl-5 pr-4'
                                            type='text'
                                            value={filterOptions.searchString}
                                            name='searchString'
                                            onChange={(e) => handleFilterChange(e.target)}
                                            placeholder={'Arama Yapın...'}
                                        />
									</span>
                                </div>

                                <div className='col-md-2'>
                                    <Calendar
                                        className={'w-100'}
                                        dateFormat='dd/mm/yy'
                                        placeholder='Başlangıç Tarihi'
                                        showButtonBar
                                        name='startDate'
                                        onChange={(e) => handleFilterChange(e.target)}
                                    />
                                </div>

                                <div className='col-md-2'>
                                    <Calendar
                                        className={'w-100'}
                                        dateFormat='dd/mm/yy'
                                        placeholder='Bitiş Tarihi'
                                        showButtonBar
                                        name='endDate'
                                        onChange={(e) => handleFilterChange(e.target)}
                                    />
                                </div>
                            </div>
                            <div className='filters-right'>
                                {getPermission('DeveloperLeave.create') && (
                                    <Button
                                        handleClick={() => createDevFunc()}
                                        className='btn-success'
                                        title={width <= 936 ? '' : 'Toplu İzin Ekle'}
                                        icon={<icons.plus />}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                    rowClassName={`cursor-pointer table-hover `}
                    value={filteredDeveloperLeaves}
                >
                    <Column
                        headerClassName='text-bold bg-primary text-default'
                        className='text-semi-bold text-sm'
                        style={{ width: 'auto', position: 'relative' }}
                        field='fullName'
                        header='Kişi Adı'
                        sortable='true'
                        body={(rowData) => {
                            const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
                            const today = moment(new Date(), 'YYYY-MM-DD')
                            const isYellow =
                                lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
                            const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60
                            return (
                                <div className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
                                    {rowData.forWhomUser?.fullName || rowData.leaveText || 'Genel İzin'}
                                </div>
                            )
                        }}
                    />
                    <Column
                        field='startDate'
                        header='İzin Başlangıç Tarihi'
                        sortable='true'
                        body={(rowData) => {
                            const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
                            const today = moment(new Date(), 'YYYY-MM-DD')
                            const isYellow =
                                lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
                            const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60
                            return (
                                <div className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
                                    {rowData.startDate && <span> {moment(rowData.startDate).format('LL')}</span>}
                                </div>
                            )
                        }}
                    />
                    <Column
                        field='endDate'
                        header='İzin Bitiş Tarihi'
                        sortable='true'
                        body={(rowData) => {
                            const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
                            const today = moment(new Date(), 'YYYY-MM-DD')
                            const isYellow =
                                lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
                            const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60

                            return (
                                <span className={`projects-list-card-footer-period cellSetTransparent text-sm ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'
                                    }`}
                                >
                                    {rowData.endDate && <span> {moment(rowData.endDate).format('LL')}</span>}
                                </span>
                            )
                        }}
                    />
                    <Column
                        headerClassName='text-bold bg-primary text-default'
                        className='text-semi-bold text-sm'
                        style={{ width: 'auto', position: 'relative' }}
                        field='department'
                        header='İzin Türü'

                        body={(rowData) => {
                            const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
                            const today = moment(new Date(), 'YYYY-MM-DD')
                            const isYellow =
                                lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
                            const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60
                            return (
                                <div className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
                                    {rowData.leaveType?.name || 'Genel'}
                                </div>
                            )
                        }}
                    />

                    <Column
                        header='Aksiyonlar'
                        body={(rowData) => {
                            const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
                            const today = moment(new Date(), 'YYYY-MM-DD')
                            const isYellow =
                                lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
                            const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60

                            return (
                                <span
                                    className={`projects-list-card-footer-period cellSetTransparent text-sm ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'
                                        }`}
                                >
                                    {
                                        <div className='d-flex gap-1'>

                                            {getPermission('DeveloperLeave.create') && (
                                                <>
                                                    <icons.edit
                                                        onClick={() => {
                                                            setEditDeveloper({
                                                                open: true,
                                                                isEdit: true,
                                                                developer: {
                                                                    ...rowData,
                                                                    startDate: rowData.startDate,
                                                                    endDate: rowData.endDate,
                                                                    leaveTypeId: rowData.leaveTypeId,
                                                                },
                                                            })
                                                            setAddDevForm({
                                                                forWhomUserId: rowData.forWhomUserId,
                                                                startDate: rowData.startDate,
                                                                endDate: rowData.endDate,
                                                                startDayPeriod: rowData.startDayPeriod,
                                                                endDayPeriod: rowData.endDayPeriod,
                                                                leaveTypeId: rowData.leaveTypeId,
                                                                description: rowData.description,
                                                                leaveText: rowData.leaveText,
                                                                id: rowData.id,
                                                                isReduceLeave:rowData.isReduceLeave
																														})
                                                            setTime2(rowData.endDate)
                                                            setTime(rowData.startDate)

                                                        }}
                                                        color='black'
                                                        className='devs-list-card-settings-icon'
                                                        size={18}
                                                    />
                                                    {' '}
                                                </>
                                                )}
                                            {getPermission('DeveloperLeave.delete') && (
                                                <>
                                                    <icons.delete
                                                        onClick={() => handleDeleteRow(rowData, '/DeveloperLeave/DeleteLeave', 'developers')}
                                                        className='devs-list-card-settings-icon mr-1'
                                                        size={18}
                                                        color='black'
                                                    />
                                                    {' '}
                                                </>
                                            )}
                                        </div>
                                    }
                                </span>
                            )
                        }}
                    />
                </DataTable>
            )}
            {createDev && (
                <Dialog style={{ width: '900px' }} visible={createDev} onHide={handleCloseModal} draggable={false} header='Toplu İzin Ekle'>
                    <div className='form d-flex flex-column gap-3 mt-2'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-control'>
                                    <label className="">Kişiler</label>
                                    <PickList dataKey="value"
                                              source={allUser.filter(c => !addDevForm.forWhomUserIds?.includes(c.id)).
                                                map((pt) => ({ label: pt.fullName, value: pt.id }))}
                                              target={addDevForm.forWhomUserIds?.map((pt) => {
                                                  let user = allUser.find(c => c.id === pt)
                                                  return { label: user?.fullName, value: user?.id }
                                              })}
                                              onChange={(e) => handleChange(e.target?.map(c => c.value) ?? [],
                                                'forWhomUserIds')}
                                              itemTemplate={(item) => item.label}
                                              breakpoint="1280px"
                                              sourceHeader="Tüm Çalışanlar"
                                              targetHeader="İzin Kullanacaklar"
                                              filterBy={'label'}
                                              sourceFilterPlaceholder="Ara"
                                              targetFilterPlaceholder="Ara"
                                              showSourceControls={false}
                                              showTargetControls={false}
                                              sourceStyle={{ height: '16rem' }}
                                              targetStyle={{ height: '16rem' }} />
                                </div>

                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-control'>
                                    <label className=''>İzin Türü</label>
                                    <DefaultSelect
                                        placeholder={"İzin Türü"}
                                        menuPlacement='top'
                                        name='leaveTypeId'
                                        value={leaveTypes.find(c => c.value === addDevForm.leaveTypeId)}
                                        selectOptions={leaveTypes}
                                        handleChange={(e) => handleChange(e?.value, "leaveTypeId")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>İzin Başlangıç Tarihi</label>

                                    <Calendar
                                        dateFormat='dd/mm/yy'
                                        placeholder='İzin Başlangıç Tarihi'
                                        name='startDate'
                                        onChange={(e) => {
                                            handleChange(moment(e.target.value, 'DD/MM/YYYY').toISOString(), e.target.name)
                                        }}
                                    />
                                </div>


                            </div>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>Başlangıç Günü Dönem</label>

                                    <DefaultSelect
                                        placeholder={"Başlangıç Günü Dönem"}
                                        name='startDayPeriod'
                                        value={leaveDayPeriodList.find(c => c.value === addDevForm.startDayPeriod)}
                                        selectOptions={leaveDayPeriodList}
                                        handleChange={(e) => handleChange(e?.value, "startDayPeriod")}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>İzin Bitiş Tarihi</label>

                                    <Calendar
                                        dateFormat='dd/mm/yy'
                                        placeholder='İzin Bitiş Tarihi'
                                        name='endDate'
                                        onChange={(e) => {
                                            handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                        }}
                                    />
                                </div>


                            </div>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>Bitiş Günü Dönem</label>

                                    <DefaultSelect
                                        placeholder={"Bitiş Günü Dönem"}
                                        name='endDayPeriod'
                                        value={leaveDayPeriodList.find(c => c.value === addDevForm.endDayPeriod)}
                                        selectOptions={leaveDayPeriodList.slice(0, 2)}
                                        handleChange={(e) => handleChange(e?.value, "endDayPeriod")}
                                    />

                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-control'>
                                    <label className=''>İzin Yazısı</label>
                                    <InputText
                                        placeholder={'İZİN'}
                                        name='leaveText'
                                        type='text'
                                        value={addDevForm.leaveText}
                                        onChange={handleChange}
                                        className='default-input input-border'
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
													<div className="col-md-12">
														<div className='form-control flex-row gap-2'>
															<Checkbox  id='isReduceLeave' checked={addDevForm.isReduceLeave == 0} onChange={() =>  handleChange(addDevForm.isReduceLeave == 0 ? 1 : 0, "isReduceLeave")} />
																								<label htmlFor="isReduceLeave" className="form-control-label">İzin hakkından düşülecek mi?</label>
														</div>
													</div>
												</div>

                        <div className='col-md-6 offset-md-6'>
                            <div className='form-control align-items-end '>
                                <Button
                                    icon={<icons.addUser className='mr-1' size={20} />}
                                    className='btn-success'
                                    title='İzin Ekle'
                                    handleClick={() => {handleSubmit()}}
                                />
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}

            {editDeveloper.open && editDeveloper.isEdit && (
                <Dialog visible={editDeveloper.open} onHide={handleCloseModal} draggable={false} header='İzin Bilgilerini Güncelle'>
                    <div className='form d-flex flex-column gap-3 mt-2'>
                        {editDeveloper.developer.forWhomUser && (
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-control'>
                                        <label className='text-bold'>Kişi Adı</label>
                                        <InputText
                                            placeholder={'Adı Soyadı'}
                                            name='fullName'
                                            type='text'
                                            value={editDeveloper.developer.forWhomUser?.fullName}
                                            onChange={handleChange}
                                            className='default-input input-border'
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className='text-bold'>İzin Başlangıç Tarihi</label>
                                    <Calendar
                                        dateFormat='dd/mm/yy'
                                        label='Başlangıç Tarihi'
                                        placeholder='Başlangıç Tarihi'
                                        name='startDate'
                                        value={addDevForm.startDate && new Date(addDevForm.startDate)}
                                        onChange={(e) => {
                                            handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                        }}
                                    />
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>Başlangıç Günü Dönem</label>

                                    <DefaultSelect
                                        placeholder={"Başlangıç Günü Dönem"}
                                        name='startDayPeriod'
                                        value={leaveDayPeriodList.find(c => c.value === addDevForm.startDayPeriod)}
                                        selectOptions={leaveDayPeriodList}
                                        handleChange={(e) => handleChange(e?.value, "startDayPeriod")}
                                    />

                                </div>
                            </div>
                        </div>

                        <div className='row'>

                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className='text-bold'>İzin Bitiş Tarihi</label>
                                    <Calendar
                                        dateFormat='dd/mm/yy'
                                        label='Bitiş Tarihi'
                                        placeholder='Bitiş Tarihi'
                                        name='endDate'
                                        value={addDevForm.endDate && new Date(addDevForm.endDate)}
                                        onChange={(e) => {
                                            handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>Bitiş Günü Dönem</label>

                                    <DefaultSelect
                                        placeholder={"Bitiş Günü Dönem"}
                                        name='endDayPeriod'
                                        value={leaveDayPeriodList.find(c => c.value === addDevForm.endDayPeriod)}
                                        selectOptions={leaveDayPeriodList.slice(0, 2)}
                                        handleChange={(e) => handleChange(e?.value, "endDayPeriod")}
                                    />

                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-control'>
                                    <label className='text-bold'>İzin Yazısı</label>
                                    <InputText
                                        placeholder={'İZİN'}
                                        name='leaveText'
                                        type='text'
                                        value={addDevForm.leaveText}
                                        onChange={handleChange}
                                        className='default-input input-border'
                                    />
                                </div>
                            </div>
                        </div>
                        {editDeveloper.developer.forWhomUser && (
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-control'>
                                        <label className='text-bold'>İzin Türü</label>

                                        <DefaultSelect
                                            placeholder={"İzin Türü"}
                                            name='leaveTypeId'
                                            value={leaveTypes.find(c => c.value === editDeveloper.developer.leaveTypeId)}
                                            selectOptions={leaveTypes}
                                            handleChange={(e) => handleChange(e?.value, "leaveTypeId")}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="row">
                            <div className="col-md-12">
                                <div className='form-control flex-row gap-2'>
                                    <Checkbox  id='isReduceLeave' checked={addDevForm.isReduceLeave == 0} onChange={() =>  handleChange(addDevForm.isReduceLeave == 0 ? 1 : 0, "isReduceLeave")} />
                                    <label htmlFor="isReduceLeave" className="form-control-label">İzin hakkından düşülecek mi?</label>
                                </div>
                            </div>
						</div>
                        {
                            (developerInfo?.remainingLeave || developerInfo?.remainingLeave == 0) &&  <div className="row">
                                <div className="col-md-12"><span className="text-bold">Kalan İzin Hakkı: </span><span>{developerInfo?.remainingLeave}</span></div>
                                <div className="col-md-12"><span className="text-bold">İzin Sonrası Kalan İzin Hakkı: </span><span>{(addDevForm.isReduceLeave == 0 && (editDeveloper.developer?.startDate != addDevForm.startDate || editDeveloper.developer?.endDate != addDevForm.endDate )) ?  Number(developerInfo?.remainingLeave - calculateIzinGun(addDevForm.startDate, addDevForm.endDate, addDevForm.startDayPeriod, addDevForm.endDayPeriod)) : developerInfo?.remainingLeave}</span></div>
                            </div>
                        }
                        <div className='col-md-6 offset-md-6'>

                            <div className='form-control align-items-end '>
                                <Button
                                    icon={<icons.edit className='mr-1' size={20} />}
                                    className='btn-success'
                                    title='Güncelle'
                                    handleClick={() => {
                                        handleSubmit()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}

            <Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
                <ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleSubmitApproval} />
            </Dialog>
        </AnimatedSpan>
    )
}

Leave.proptypes = {
    createDev: PropTypes.bool,
    setCreateDev: PropTypes.func,
}
export default Leave
